import { jsx as _jsx } from "react/jsx-runtime";
import { useWindowSize } from "usehooks-ts";
import { socketConnectedSelector } from "../slices/connectionSlice";
import { useSelector } from "react-redux";
export const InopX = () => {
    const windowSize = useWindowSize();
    const socketConnected = useSelector(socketConnectedSelector);
    return !socketConnected ? (_jsx("graphics", { label: "INOP_X", eventMode: "none", zIndex: 10000, draw: (graphics) => {
            graphics.clear();
            graphics.moveTo(3, 0);
            graphics.lineTo(windowSize.width, windowSize.height - 3);
            graphics.moveTo(0, 3);
            graphics.lineTo(windowSize.width - 3, windowSize.height);
            graphics.moveTo(windowSize.width, 3);
            graphics.lineTo(3, windowSize.height);
            graphics.moveTo(windowSize.width - 3, 0);
            graphics.lineTo(0, windowSize.height - 3);
            graphics.stroke({ width: 1, color: 0xff0000 });
        } })) : null;
};
//# sourceMappingURL=InopX.js.map